<!-- prize.wxml -->
<template>
    <div class="member-order-box">
        <!-- tab -->
        <div class="type-tab">
            <div v-for="(item,index) in typeList" :style="{width:100 / typeList.length + '%'}" :key="index"
                 :class="['tab-item',item.type == dataType ? ' active':'']" @click="getType(item.type)">
                <div class="item">{{item.name}}</div>
            </div>
        </div>
        <!-- tab end -->
        <!-- prize -->
        <div class="order-list" v-if="list.length > 0">
            <nut-infiniteloading
                @loadmore="onInfinite"
                :is-show-mod="true"
                :has-more="isHasMore"
                :is-loading="isLoading"
                :threshold="20"
            >
                <div class="list-item" style="margin-top: 30px" v-for="(item,index) in list" :key="index">
                    <!--                    分割线-->
                    <div style="height: 10px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
                    <!--                    分割线 -->
                    <router-link :to="{path:'/order/refund/detail',query:{order_refund_id:item.order_refund_id}}">
                        <div style="padding-top: 10px">
                            <span style="color: #555;">{{item.create_time}}</span>
                            <div style="float: right;color: #ff5656;font-size: 13px;font-weight: 500;">
                                {{item.state_text}}
                            </div>
                        </div>
                        <div class="goods-list-box" style="padding-top: 10px">
                            <div class="goods-list clearfix">
                                <div class="image">
                                    <img :src="item.order_goods.image.file_path"/>
                                </div>
                                <div class="goods-detail skeleton-rect">
                                    <div class="title skeleton-rect">{{item.order_goods.goods_name}}</div>
                                    <div class="price-box">
                                        <div class="num skeleton-rect">X {{item.order_goods.total_num}}</div>
                                    </div>
                                </div>
                                <div class="detail-order-money">
                                    <div>商品金额：<span class="col-m">${{ item.order_goods.total_pay_price }}</span></div>
                                    <div>订单实付金额：<span class="col-m">${{ item.order_master.pay_price }}</span></div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                    <div class="btn-detail">
                        <div class="btn-click" @click="onTargetDetail(item.order_refund_id)">查看详情</div>
                    </div>
                </div>
            </nut-infiniteloading>
        </div>
        <!-- no-result -->
        <div class="noresult" v-else>
            <div class="cot">
                <div class="img">
                    <img src="../../../assets/images/no_result.png">
                </div>
                <p class="text" style="color: #aaa">暂无退款/售后单</p>
                <router-link class="browse-btn" to="/">点击逛逛</router-link>
            </div>
        </div>
        <!-- no-result end -->
    </div>
</template>
<script>
    import Tabber from '@/components/Tabber.vue'

    export default {
        name: 'OrderRefundIndex',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                dataType: -1,
                typeList: [
                    {
                        name: '全部',
                        type: -1,
                    },
                    {
                        name: '待处理',
                        type: 0,
                    }
                ],
                list: [],
                applyStatus: [],
                no_more: false, // 没有更多数据
                page: 1, // 当前页码
                current_page: 1,
                last_page: 1,
                isHasMore: true,
                isLoading: false,
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.dataType = _this.$route.query.type || -1;
            // 获取退款/售后单列表
            _this.getRefundList();
        },
        methods: {

            /**
             * 获取退款/售后单列表
             */
            getRefundList(page = 1) {
                let _this = this;
                _this._get('user.refund/lists', {
                    state: _this.dataType,
                    page: page,
                }, (result) => {
                    // 创建页面数据
                    _this.loading.hide();
                    _this.list = _this.list.concat(result.data.list.data);
                    _this.current_page = result.data.list.current_page;
                    _this.last_page = result.data.list.last_page;
                    _this.isLoading = false;
                    _this.isHasMore = result.data.list.data > 0 ? true : false;
                });
            },


            /**
             * 顶部切换事件
             */
            getType: function (type) {
                let _this = this;
                _this.dataType = type;
                this.loading = this.$toast.loading('Loading...', {
                    coverColor: "rgba(0,0,0,0.5)",
                });
                _this.list = [];
                _this.getRefundList();
            },

            /**
             * 跳转售后详情页
             */
            onTargetDetail(order_refund_id) {
                let _this = this;
                _this.navigationTo('/order/refund/detail', {order_refund_id: order_refund_id});
            },

            /**
             *  触底加载
             */
            onInfinite: function () {
                if (this.current_page >= this.last_page) {
                    this.isLoading = false;
                    this.isHasMore = false;
                    return false;
                }
                this.isLoading = true;
                this.isHasMore = true;
                this.getRefundList(this.current_page + 1);
            },
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss">
    @import "index";
</style>
